<template>
    <div>
        <div
            ref="inner"
            class="l-ss-c-completions-inner"
            :class="{ 'l-ss-c-completions-inner-empty': hasOnlyPopularOffers }"
            @scroll="handleShowBarGradient">
            <div
                v-if="isShowLeftSection"
                class="l-ss-c-completions-inner-left">
                <taps
                    v-if="showTaps"
                    :query="query"
                    :data="tapsComplitions"
                    is-taps-complitions
                    :count="tapsCount"
                    @handle-tags-click="emitHandleTagsClick"
                    @preview-tab-click="emitPreviewTabClick"/>

                <div
                    v-for="(group, groupIndex) in groups.other"
                    :key="groupIndex"
                    class="l-ss-c-completions-group"
                    :class="{ 'l-ss-c-completions-group-with-label': showCompletionsLabel }"
                    @click="handleClick"
                    @contextmenu="handleClick($event, 'contextmenu')">
                    <template v-if="group.label !== 'brands'">
                        <div
                            class="l-ss-c-completions-group-label"
                            v-if="showCompletionsLabel">
                            {{ $t(`completions.category.${group.label}`) }}
                        </div>

                        <completions-item
                            v-for="(item, itemIndex) in group.items"
                            v-show="isItemVisible(item)"
                            :key="item._id"
                            :data="item"
                            :data-id="item._id"
                            :data-position="itemIndex + 1"
                            :is-active="itemIndex === activeIndex"
                            :is-cart-available="$configuration.features.addToCartButton"
                            :is-cat-prefix-active="$configuration.features.catPrefix"
                            @add-to-cart="emitAddToCart"
                            @remove-history="emitRemoveHistory"/>
                    </template>

                    <completions-item-brand
                        v-else
                        :brands="group.items"/>
                </div>

                <div
                    v-if="$configuration.skuStrict && completions.length === 0"
                    class="l-ss-c-completions-sku">
                    <p class="l-ss-c-completions-sku-empty-title">{{ $t('completions.emptyResultsBySku') }}</p>
                    <button
                        class="l-ss-c-button l-ss-c-button-large"
                        @click="handleEmptyResetClick">
                        {{ $t('categories.emptyListButtonResetQuery') }}
                    </button>
                </div>
            </div>
            <div
                :class="{ 'l-ss-c-completions-inner-right-no-query': !query || query.trim() === '' }"
                class="l-ss-c-completions-inner-right">
                <section-results-empty
                    v-if="hasOnlyPopularOffers"
                    :search="{ query }"
                    :popular-queries="popularQueries"
                    :popular-offers="popularOffers"
                    is-completions
                    @scroll.native="handleShowBarGradient"
                    v-on="completionsWrapperEventListeners"/>

                <template v-else>
                    <div
                        v-for="(group, groupIndex) in groups.offers"
                        :key="groupIndex"
                        ref="completionsGroup"
                        :class="{
                            'l-ss-c-completions-group-offers': group.label === 'offers',
                            'l-ss-c-completions-group-extra-offers': group.label === 'extraOffers',
                        }"
                        class="l-ss-c-completions-group"
                        @click="handleClick"
                        @contextmenu="handleClick($event, 'contextmenu')"
                        @scroll="handleShowBarGradient">
                        <completions-item-offer-wrapper
                            :offers="group.items"
                            :has-left-section="isShowLeftSection"
                            :offers-label="group.label"
                            :query="query"
                            v-on="completionsItemOfferWrapperEventListeners"/>
                    </div>
                </template>

                <div
                    class="l-ss-c-completions-bar"
                    :class="{ 'l-ss-c-completions-bar-not-empty': (isVisibleShowAllButton || isShowSignature) && !hasOnlyPopularOffers }"
                    ref="completionsBar">
                    <template v-if="(isVisibleShowAllButton || isShowSignature) && !hasOnlyPopularOffers">
                        <button
                            v-if="isVisibleShowAllButton"
                            class="l-ss-c-completions-show-all"
                            @click="searchAll">
                            <span>
                                {{ $t('completions.showAll') }}
                            </span>
                            <i v-html="iconArrowRight"></i>
                        </button>
                        <signature v-if="isShowSignature"/>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { OFFER_KEYS } from '@/config';
    import CompletionsItem from './completions-item';
    import CompletionsItemBrand from '@/core/components/completions/completions-item-brand.vue';
    import Taps from '@/core/components/taps.vue';
    import CompletionsItemOfferWrapper from '@/core/components/completions/completions-item-offer-wrapper.vue';
    import SectionResultsEmpty from '../section-results/section-results-empty.vue';
    import iconArrowRight from '@/core/assets/images/icons/arrow-right-results.svg';
    import Signature from '@/core/components/signature';
    import EventEmitterMixin from '../../mixins/event-emitter';
    import { commonOfferEventHandlers, mapHandlers } from '../../mixins/event-emitter';

    const START_ANIMATION_DELAY = 1000;

    export default {
        components: {
            CompletionsItemOfferWrapper,
            Taps,
            CompletionsItem,
            CompletionsItemBrand,
            SectionResultsEmpty,
            Signature,
        },
        mixins: [EventEmitterMixin],
        inject: ['store'],
        props: {
            completions: {
                type: Array,
                default: () => ([]),
            },
            tapsComplitions: {
                type: Array,
                default: () => ([]),
            },
            query: {
                type: String,
                default: '',
            },
            search: {

            },
            isShowSignature: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                activeIndex: null,
                dataSet: {},
                completionTarget: {},
                disabledAnimation: true,
                hasOnlyPopularOffers: false,
            };
        },
        computed: {
            taps() {
                return {
                    desktop: (this.$configuration.completions?.taps?.desktop) ? this.$configuration.completions?.taps?.desktop : {},
                    mobile: (this.$configuration.completions?.taps?.mobile) ? this.$configuration.completions?.taps?.mobile : {},
                };
            },
            iconArrowRight() {
                return iconArrowRight;
            },
            showTaps() {
                return ((this.$screen.isMobile && this.taps.mobile.active) ||
                    (!this.$screen.isMobile && this.taps.desktop.active)) &&
                    !!this.tapsComplitions.length;
            },
            tapsCount() {
                return (this.$screen.isMobile) ? this.taps.mobile.count : this.taps.desktop.count;
            },
            groups() {
                let groups = {
                    other: [],
                    offers: [],
                };

                const insertCompletion = (completion, completionLabel, groupItem) => {
                    const completionGroup = groupItem.find(group => group.label === completionLabel);
                    if (completionGroup) {
                        completionGroup.items.push(completion);
                    } else {
                        groupItem.push({
                            label: completionLabel,
                            items: [completion],
                        });
                    }
                };

                this.completions.forEach(completion => {
                    const completionLabel = completion.label;

                    if (OFFER_KEYS.includes(completionLabel)) {
                        insertCompletion(completion, completionLabel, groups.offers);
                    } else {
                        insertCompletion(completion, completionLabel, groups.other);
                    }
                });

                return groups;
            },
            showCompletionsLabel() {
                return this.$configuration.completions.showCompletionsLabel;
            },
            allCompletionsHidden() {
                return this.completions.some(item => item.visible === true) === false;
            },
            skuStrict() {
                return this.$configuration.skuStrict;
            },
            isSku() {
                return Boolean((this.query || '').match(this.$configuration.skuRegExp));
            },
            isShowLeftSection() {
                return this.showTaps || !!this.groups.other.length;
            },
            isVisibleShowAllButton() {
                return this.completions.length > 0 && this.query?.trim();
            },
            popularQueries() {
                if (window['searchbooster']) {
                    return window['searchbooster'].api?.controller?.popularQueries || [];
                }
                return [];
            },
            popularOffers() {
                if (window['searchbooster']) {
                    return window['searchbooster'].api?.controller?.popularOffers || [];
                }
                return [];
            },
            completionsWrapperEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                    'autocomplete-search': this.emitAutocompleteSearch,
                    'handle-tags-click': this.emitChangeQueryAndSearch,
                    'search-input-change': this.emitSearchInputChange,
                };
            },
            completionsItemOfferWrapperEventListeners() {
                return mapHandlers(this, commonOfferEventHandlers);
            },
        },

        watch: {
            query: {
                immediate: true,
                handler() {
                    if (window['searchbooster']) {
                        this.hasOnlyPopularOffers = window['searchbooster'].api.controller.hasOnlyPopularOffersInCompletions;
                    }
                },
            },
            completions: {
                handler() {
                    this.$refs.inner.scrollTo(0, 0);
                },
            },
        },
        created() {
            setTimeout(() => {
                this.disabledAnimation = false;
            }, START_ANIMATION_DELAY);
        },
        mounted() {
            this.initShowBarGradientListener();
        },
        methods: {
            isItemVisible(item) {
                return item.visible || this.allCompletionsHidden && this.skuStrict;
            },
            handleEmptyResetClick(event) {
                event.preventDefault();
                event.stopPropagation();
                this.emitResetQuery();
            },
            handleClick(event, customEventType = null) {
                event.stopPropagation();
                if (this.completionTarget) {
                    const path = event.path || (event.composedPath && event.composedPath());
                    const completionTarget = path.find(element => element.dataset && element.dataset?.id);
                    if (completionTarget) {
                        const dataSet = completionTarget.dataset;
                        if (completionTarget) {
                            const completion = this.completions.find(item => item._id && item._id === dataSet.id);
                            this.$emit('click', {
                                event: event,
                                completion: completion,
                                position: dataSet.position,
                                customEventType,
                            });
                        }
                    }
                }
            },
            initShowBarGradientListener() {
                const checkMountNode = () => {
                    const completionsGroup = this.$refs.completionsGroup;

                    if (!completionsGroup || !completionsGroup.length) {
                        setTimeout(checkMountNode);
                        return;
                    }

                    let target = completionsGroup[0];

                    if (this.$screen.isMobile) {
                        target = this.$refs.inner;
                    }

                    this.handleShowBarGradient({ target });
                };

                setTimeout(checkMountNode);
            },
            handleShowBarGradient(event) {
                const target = event.target;
                const completionsBar = this.$refs.completionsBar;

                if (!completionsBar) {
                    return;
                }

                if (!target.scrollHeight || Math.round(target.clientHeight + target.scrollTop) >= target.scrollHeight) {
                    completionsBar.classList.add('l-ss-c-completions-bar-without-gradient');
                } else {
                    completionsBar.classList.remove('l-ss-c-completions-bar-without-gradient');
                }
            },
            searchAll(event) {
                this.emitSearchAll();
                this.emitPreviewShowAllClick({ type: 'previewShowAllClick', event });
            },
            emitChangeQueryAndSearch(query) {
                this.emitSearchInputChange({ query, focus: false });
                this.emitHandleSearch();
            },
        },
    };
</script>
